import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';
import { Wallpaper } from '../../models/wallpaper.model';

// Note: The following commands are not supported by iOS (yet) or require an iPad with LTE or require 'Shared iPad Mode'.
// VoiceRoaming, DataRoaming, PersonalHotspot, PassCodeLockGracePeriod, MaximumResidentUsers, DiagnosticSubmission, AppAnalytics.
// For more info reference the Apple MDM Protocol Reference (p.65-69).

// ============================================================================
// COMMAND ACTIONS
// ============================================================================

export const ManagedSettingsCommandActions = createActionGroup({
  source: 'Managed Settings Command',
  events: {
    'App Analytics': props<{ udid: string; enabled: boolean }>(),
    'Application Attributes': props<{ udid: string; identifier: string; vpnuuid: string }>(),
    Bluetooth: props<{ udid: string; enabled: boolean }>(),
    'Data Roaming': props<{ udid: string; enabled: boolean }>(),
    'Device Name': props<{ udid: string; deviceName: string }>(),
    'Diagnostic Submission': props<{ udid: string; enabled: boolean }>(),
    'Host Name': props<{ udid: string; hostName: string }>(),
    'Maximum Resident Users': props<{ udid: string; maximumResidentUsers: number }>(),
    'MDM Options': props<{ udid: string; activationLockAllowedWhileSupervised?: boolean }>(),
    'Pass Code Lock Grace Period': props<{ udid: string; passCodeLockGracePeriod: number }>(),
    'Personal Hotspot': props<{ udid: string; enabled: boolean }>(),
    'Set Wallpaper': props<{ wallpaper: Wallpaper; udid: string }>(),
    'Voice Roaming': props<{ udid: string; enabled: boolean }>(),
    Request: props<{ udid: string }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const ManagedSettingsApiActions = createActionGroup({
  source: 'Api MDM Command',
  events: {
    'Set Wallpaper Succeeded': props<{ udid: string }>(),
    'Set Wallpaper Failed': props<{ udid: string; error: ErrorModel }>(),
    'Bluetooth Succeeded': props<{ udid: string }>(),
    'Bluetooth Failed': props<{ udid: string; error: ErrorModel }>(),
    'Applications Attributes Succeeded': props<{ udid: string }>(),
    'Applications Attributes Failed': props<{ udid: string; error: ErrorModel }>(),
    'Devicename Succeeded': props<{ udid: string }>(),
    'Devicename Failed': props<{ udid: string; error: ErrorModel }>(),
    'MDM Options Succeeded': props<{ udid: string }>(),
    'MDM Options Failed': props<{ udid: string; error: ErrorModel }>(),
    'Pass Code Lock Grace Period Succeeded': props<{ udid: string }>(),
    'Pass Code Lock Grace Period Failed': props<{ udid: string; error: ErrorModel }>(),
    'Maximum Resident Users Succeeded': props<{ udid: string }>(),
    'Maximum Resident Users Failed': props<{ udid: string; error: ErrorModel }>(),
    'Diagnostic Submission Succeeded': props<{ udid: string }>(),
    'Diagnostic Submission Failed': props<{ udid: string; error: ErrorModel }>(),
    'App Analytics Succeeded': props<{ udid: string }>(),
    'App Analytics Failed': props<{ udid: string; error: ErrorModel }>(),
    'Host Name Succeeded': props<{ udid: string }>(),
    'Host Name Failed': props<{ udid: string; error: ErrorModel }>(),
    'Voice Roaming Succeeded': props<{ udid: string }>(),
    'Voice Roaming Failed': props<{ udid: string; error: ErrorModel }>(),
    'Data Roaming Succeeded': props<{ udid: string }>(),
    'Data Roaming Failed': props<{ udid: string; error: ErrorModel }>(),
    'Personal Hotspot Succeeded': props<{ udid: string }>(),
    'Personal Hotspot Failed': props<{ udid: string; error: ErrorModel }>(),
  },
});
